let getPickers = () => {
	return import(/* webpackChunkName: "logDictionaryAutocompleteControl" */ './LogDictionaryAutocompleteControl').then((module) => {
		return module;
	});
}

export default {
	reload: (rootElement?: HTMLElement) => {
		const nodes = (rootElement || document).querySelectorAll(".qd-react-log-autocomplete-control");
		if (nodes.length != 0) {
			getPickers().then(module => {
				for (let i = 0; i < nodes.length; i++) {
					let node = nodes[i] as HTMLElement;

					module.renderControl(node);
				}
			})
			.catch(error => console.error(error));
		}
	}
}